import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/networkHandler";
export const tokenConfig = (getState) => {
  const token = getState().auth.accessToken;

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
};

//Get Top Board
export const getTopBoard = createAsyncThunk(
  "dashboard/getTopBoard",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/top-board`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//Get Performance Analytics
export const getAnalytics = createAsyncThunk(
  "dashboard/getPerformanceAnalytics",
  async ({year}, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      let params = '';
      if (year) {
        params += `year=${encodeURIComponent(year)}`;
      }
      const response = await axios.get(`/admin/analytics?${params}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
//Get Top Campaigns
export const getTopCampaigns = createAsyncThunk(
  "dashboard/getTopCampaigns",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(
        `/admin/top-campaigns`,
        config
      );
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//Get Top Publishers
export const getTopPublishers = createAsyncThunk(
  "dashboard/top-publishers",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/top-publishers`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//Get Top Advertisers
export const getTopAdvertisers = createAsyncThunk(
  "/dashboard/top-advertisers",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/top-advertisers`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    topBoard: {},
    analytics: [],
    topCampaigns: [],
    topPublishers: [],
    topAdvertisers: [],
    loading: false,
    error: null,
    meta: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // get-top-board
      .addCase(getTopBoard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTopBoard.fulfilled, (state, action) => {
        state.topBoard = action.payload.data;
        state.loading = false;
      })
      .addCase(getTopBoard.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // get-analytics
      .addCase(getAnalytics.pending, (state) => {
        state.loading = true
        })
        .addCase(getAnalytics.fulfilled, (state, action) => {
          state.analytics = action.payload.data;
          state.loading = false;
        })
        .addCase(getAnalytics.rejected, (state, action) => {
          state.error = action.payload;
          state.loading = false;
      })
      // get-top-campaigns
      .addCase(getTopCampaigns.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTopCampaigns.fulfilled, (state, action) => {
        state.topCampaigns = action.payload.data;
        state.meta = action.payload.meta; // Store pagination meta
        state.loading = false;
      })
      .addCase(getTopCampaigns.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // get-top-publishers
      .addCase(getTopPublishers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTopPublishers.fulfilled, (state, action) => {
        state.topPublishers = action.payload.data;
        state.loading = false;
      })
      .addCase(getTopPublishers.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // get-top-advertisers
      .addCase(getTopAdvertisers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTopAdvertisers.fulfilled, (state, action) => {
        state.topAdvertisers = action.payload.data;
        state.loading = false;
      })
      .addCase(getTopAdvertisers.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default dashboardSlice.reducer;
